<template>
    <footer class="footer">
        <div class="footer__content">
            <div class="socialMedia">
                <div class="contact">
                    <a href="https://www.msi.com/about/contact-us"
                        >Contact Us</a
                    >
                    <a href="https://www.msi.com/page/privacy-policy"
                        >Privacy Policy</a
                    >
                    <a href=" https://www.msi.com/page/website-terms-of-use"
                        >Terms of Use</a
                    >
                </div>
                <div class="language">
                    <button @click="changeToMadrain">繁體中文</button>
                    <span>|</span>
                    <button @click="changeToEnglish">English</button>
                </div>
            </div>
            <div class="tradeMark">
                <!-- <figure class="logo">
                    <img
                        src="https://www.msi.com/images/imgs/footer_msilogo.png"
                        alt=""
                    />
                </figure> -->
                <div class="copyRight">
                    Copyright © 2026 Micro-Star Int'l Co.,Ltd. All rights
                    reserved.
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: "Footer",
    data() {
        return {};
    },
    methods: {
        changeToMadrain() {
            this.fetchLangAPI("tw");
        },
        changeToEnglish() {
            this.fetchLangAPI("global");
        },
        fetchLangAPI(currentLang) {
            this.$router.push({
                name: this.$route.name,
                params: { lang: currentLang },
            });
        },
    },
};
</script>

<style lang="sass" scoped>
.footer
	background-color: #828282
	padding: 15px
	color: #fff
	margin-top: 35px
	&__content
		text-align: center
		@media (min-width:960px)
			display: flex
		.socialMedia
			width: 90%
			font-size: 14px
			line-height: 20px
			margin: 0 auto 10px
			@media (min-width: 540px)
				display: flex
				justify-content: center
				align-items: center
			@media (min-width:960px)
				margin-bottom: 0
				flex: 1 0 0
			.contact
				a
					color: #fff
					text-decoration: none
					&:hover
						color: #d1d1d1
				a+a
						margin-left: 10px
			.language
				margin-top: 5px
				@media (min-width:540px)
					margin-top: 0
					margin-left: 10px
				button
					color: #fff
					background-color: unset
					border: unset
					cursor: pointer
					&:hover
						color: #d1d1d1
				span
					margin: 0 8px
		.tradeMark
			display: flex
			align-items: center
			@media (min-width: 540px)
				justify-content: center
			@media (min-width:960px)
				flex: 1 0 0
				order: -1
			.logo
				img
					width: 100%
					vertical-align: middle
			.copyRight
				margin-left: 10px
				vertical-align: middle
</style>
